// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class MultipleFileFormView extends JQueryView {
  constructor() {
    super('#upload_multiple_files_form');
  }

  @on({ event: 'change', selector: '.file-input' })
  onChangeFile(e: any) {
    let fileCount = $(e.target).data('file-number');
    const fileName = $(`.file-input-${fileCount}`).prop('files')[0].name;
    $(`.file-name-${fileCount}`).html(fileName);
  }
}
